module.exports = __webpack_public_path__ + "static/img/begin-answer.d80cea1.png";


//////////////////
// WEBPACK FOOTER
// ./static/runtime/images/magic/begin-answer.png
// module id = 3Gnx
// module chunks = 1